// Constants for various configurations
const VARIANT_ID = 48889375818032; // Unique ID for the gift wrapping variant
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 28: skal ændres sammen med GIFT_WRAP_VARIANT_ID i assets/custom.js
const PRICE_REGEX = /[\d|,|\.]+/; // Regex to match price formats
const NUMBER_REGEX = /\d+/; // Regex to match numbers
const WRAP_PRICE = 5; // Price of gift wrapping
const SESSION_KEY = "gift_wrap_session"; // Key to store gift wrap session data
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - kurv-kald afbrydes efter 15 sek., så et hængende net ikke låser "Til kassen" og gave-køen for altid
const requestTimeout = () => (AbortSignal.timeout ? AbortSignal.timeout(15000) : undefined);

// Options to format numbers to 2 decimal places
const NUMBER_LOCALE_OPTIONS = {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
};

// Function to prevent checkout while a task is running
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - kun "Til kassen" låses, til gavevalg og note er skrevet. Gavefelterne låses ikke
// (før gik hurtige klik på næste felt tabt); kørslerne sættes i stedet i kø i setCartState, så de ikke overlapper.
// Låsen tæller kørsler og låses først op, når den sidste er færdig (finally: også ved netfejl).
// Kurv-skuffen kan skifte "Til kassen"-knappen ud undervejs (assets/cart.js), så knappen findes igen ved låsning og oplåsning,
// og et klik på en ny, ulåst knap stoppes af lytteren nedenfor. Kun knapper, låsen selv har slået fra, slås til igen (ikke fx "Til kassen" i en tom kurv).
const CHECKOUT_SELECTOR = "#CartDrawer-Checkout";
let checkoutLocks = 0;

document.addEventListener(
	"click",
	e => {
		if (checkoutLocks > 0 && e.target.closest && e.target.closest(CHECKOUT_SELECTOR)) {
			e.preventDefault();
			e.stopPropagation();
		}
	},
	true
);

async function preventCheckout(callback) {
	checkoutLocks++;
	document.querySelectorAll(CHECKOUT_SELECTOR).forEach(elm => {
		if (elm.disabled) return;
		elm.disabled = true;
		elm.dataset.giftLocked = "";
	});

	try {
		return await callback();
	} finally {
		checkoutLocks--;
		if (checkoutLocks === 0) {
			document.querySelectorAll("[data-gift-locked]").forEach(elm => {
				elm.disabled = false;
				delete elm.dataset.giftLocked;
			});
		}
	}
}

// Kø for setCartState: én kurv-opdatering ad gangen, hver med det nyeste valg fra sessionen
let cartStateQueue = Promise.resolve();

// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 7: et gavevalg hører til kurvlinjen (Shopifys line key), ikke til variant-ID'et.
// Før fik to linjer med samme vare og størrelse kun ét valg. Sessionen gemmer [{ "<line key>": "Gave 1" }, ...].
// En linjes key skifter, når dens egenskaber ændres; rememberNewLineKey flytter valget til den nye key (session og side).
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.6) - audit 6: flytningen af valg gemt før v3.5 (under variant-ID) er slettet efter aftale.
// Har en kunde gaveindpakning valgt i en åben fane, mens temaet opdateres, fjernes indpakningen fra kurven, og kunden skal vælge igen.
const lineKey = v => Object.keys(v)[0];
const lineValue = v => Object.values(v)[0];
// "Gave 3" → 3
const giftNumber = value => parseInt(value.replace(/\D/g, ""), 10) || 0;
// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 42: kurvens linjer, som skuffen viser dem (key skifter med egenskaberne)
const lineSignature = cart => ((cart && cart.items) || []).map(item => item.key + ":" + item.quantity).join(",");

// Gavevalgene, som de står på kurvens linjer
function valuesFromCart(items) {
	return items
		.filter(item => item.properties && item.properties.Gaveindpakning)
		.map(item => ({ [item.key]: item.properties.Gaveindpakning }));
}

// Én post pr. linje (to linjer kan blive lagt sammen af Shopify, når de bliver ens)
function uniqueByLine(values) {
	const seen = new Set();
	return values.filter(v => !seen.has(lineKey(v)) && seen.add(lineKey(v)));
}

function rememberNewLineKey(oldKey, newKey) {
	if (!newKey || newKey === oldKey) return;
	const { values } = getParsedSessionProgress();
	if (values) storeSessionProgress(uniqueByLine(values.map(v => (lineKey(v) === oldKey ? { [newKey]: lineValue(v) } : v))));
	document.querySelectorAll("wrap-select").forEach(elm => {
		if (elm.dataset.key === oldKey) elm.dataset.key = newKey;
	});
}

// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 8: gavevalget huskes pr. fane, men kurven er fælles.
// Når kunden vender tilbage til en fane, læses valget igen fra kurven, så krydset ikke viser noget forældet
// (og fanen ikke lægger en indpakning, der er fravalgt i en anden fane, i kurven igen).
document.addEventListener("visibilitychange", () => {
	if (document.visibilityState !== "visible") return;
	const giftWrapping = document.querySelector("gift-wrapping");
	if (giftWrapping) giftWrapping.syncFromCart();
});

// Custom element class for managing gift wrapping (re-renders on the cart update)
class GiftWrapping extends HTMLElement {
	constructor() {
		super();

		// Elements related to the total price and gift wrap checkbox
		this.price = this.querySelector(".totals__total-value");
		this.checkbox = this.querySelector("input#gift-wrap-checkbox");
		this.initialRender = true;

		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - lytteren sidder på selve elementet (delegering, sat i constructor, så den kun kommer på én gang), fordi kurv-skuffen
		// tegner indholdet om, når en vare fjernes. Før mistede det nye afkrydsningsfelt sin lytter, så indpakning ikke kunne slås fra.
		// Sessionen gemmes før setCartState, så updateCartPrice ser det nye valg.
		this.addEventListener("change", e => {
			if (e.target.id !== "gift-wrap-checkbox") return;
			e.stopPropagation();
			const isChecked = e.target.checked;

			storeSessionProgress(undefined, isChecked);
			this.setCartState(isChecked);
		});
	}

	connectedCallback() {
		// Retrieve session data
		const { checked } = getParsedSessionProgress();

		// If wrapping was previously selected, update the checkbox state
		// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.8) - "Gå til gaveindpakning" (#is-wrapping) er fjernet, så kun krydset sættes (også de 3 steder nedenfor)
		if (checked) this.checkbox.checked = true;

		// Set the cart state based on the checkbox status
		this.setCartState(checked);

		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - punkt 2: når kurven ændres (fx en vare fjernes), tælles gaveindpakningerne igen.
		// Sessionen bruges i stedet for afkrydsningsfeltet, fordi kurven tegnes om, og så er feltet et nyt, tomt element (det sættes igen her).
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
			if (event && event.source === "packaging-fee") return;
			if (!getParsedSessionProgress().checked) return;
			const checkbox = this.querySelector("#gift-wrap-checkbox");
			if (checkbox) checkbox.checked = true;
			this.setCartState(true);
		});

		this.initialRender = false;
	}

	// Kurv-skuffen udskifter hele elementet efter "læg i kurv"; den gamle lytter fjernes, så de ikke hober sig op
	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
	}

	// Set the cart state based on whether gift wrapping is selected
	setCartState(checked = false) {
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - "Til kassen" låses med det samme, men kørslen venter på den forrige (kø).
		// initialRender huskes her, fordi den er false, når kørslen når frem.
		const isInitialRender = this.initialRender;
		const previous = cartStateQueue;
		cartStateQueue = preventCheckout(async () => {
			await previous;
			// If it's the initial render and wrapping is not selected, clear session
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 26: gavevalget huskes kun i fanen (sessionStorage), men kurven er fælles.
			// Ligger der indpakning i kurven (tidligere besøg eller en anden fane), gendannes valget fra varernes "Gaveindpakning"-linjer,
			// så kunden kan se det, de betaler for. Før lå indpakningen skjult i kurven, mens feltet ikke var krydset af.
			// Tom kurv: intet kurv-opslag (de fleste sidevisninger).
			if (isInitialRender && !checked) {
				// Kunden har valgt gaveindpakning, mens kørslen stod i kø: den nyere kørsel gælder, så valget må ikke slettes
				if (getParsedSessionProgress().checked) return;
				clearSessionProgress();
				if (document.querySelector("cart-drawer.is-empty")) return;
				const cart = await getCartData();
				// Kunden har selv klikket, mens kurven blev hentet: det valg gælder
				if (getParsedSessionProgress().checked !== undefined) return;
				const items = cart.items || [];
				if (!items.some(item => item.variant_id === VARIANT_ID)) return;

				storeSessionProgress(valuesFromCart(items), true);
				checked = true;
				const checkbox = this.querySelector("#gift-wrap-checkbox");
				if (checkbox) checkbox.checked = true;
				// Varernes "Pak ind som gave?"-felter og "Gave 1/2"-valg sættes igen ud fra sessionen
				document.querySelectorAll("wrap-select").forEach(wrapSelect => {
					wrapSelect.initialRender = true;
					wrapSelect.addOptionValues();
					wrapSelect.initialRender = false;
				});
			}

			// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 42: kurven, som skuffen viser nu, så det kan ses bagefter, om denne kørsel har ændret den
			const cartBefore = await getCartData();

			// Restore or clear wrapping items based on checkbox status
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 25: ingen lås inden i låsen (den inderste låste "Til kassen" op for tidligt)
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.6) - audit 4: én funktion (setWrapCount) i stedet for to næsten ens
			let data = checked
				? await this.restoreWappingItems(cartBefore)
				: await this.setWrapCount(0);
			// Fejlsvar (fx 422) har ingen varer: kurven hentes, så antallet nedenfor er rigtigt
			if (!data || !data.items) data = await getCartData();

			// Update the cart price and item count display
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 25: await, så "Til kassen" først låses op, når gavevalget står på varen og i noten.
			// Før kunne kunden nå til kassen med betalt indpakning, men uden besked om, hvad der skulle pakkes ind.
			const cartAfter = await updateCartPrice(data);
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.6) - audit 2: samme antal som Liquid (cart.item_count, alle linjer).
			// Før blev indpakningen trukket fra her, men ikke i Liquid, så "3 stk." sprang til "2 stk."
			this.setItemCount(data.item_count);

			// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 42: er kurvens linjer ændret (indpakning lagt i/fjernet, ny gave = ny key, linjer lagt sammen),
			// tegnes skuffen om. Før viste den de gamle linjer og linjenumre, så "minus" kunne ramme en anden vare (set live 19-10-2026).
			// Næste kørsel finder intet at ændre og tegner ikke om, så det kører ikke i ring.
			if (lineSignature(cartAfter) !== lineSignature(cartBefore)) publish(PUB_SUB_EVENTS.cartUpdate, { source: "gift-wrapping" });
		}).catch(error => {
			// En fejlet kørsel må ikke stoppe køen
			console.error("Error updating gift wrapping:", error);
		});
	}

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 8: fanens valg sættes ud fra kurven (se visibilitychange øverst).
	// Kører i samme kø som setCartState. Er noget ændret, tegnes kurven om med den almindelige "kurven er ændret"-besked,
	// så linjerne får deres nye keys og gavefelter.
	syncFromCart() {
		const previous = cartStateQueue;
		cartStateQueue = preventCheckout(async () => {
			await previous;
			if (document.querySelector("cart-drawer.is-empty")) return;
			const sessionBefore = sessionStorage.getItem(SESSION_KEY);
			const items = (await getCartData()).items || [];
			// Kunden har klikket, mens kurven blev hentet: det klik gælder
			if (sessionStorage.getItem(SESSION_KEY) !== sessionBefore) return;
			const session = getParsedSessionProgress();
			const hasWrap = items.some(item => item.variant_id === VARIANT_ID);
			// Krydset er sat, men ingen vare er valgt endnu: så ligger der ingen indpakning i kurven, og der er intet at rette
			if (!hasWrap && session.checked && !(session.values || []).length) return;
			const checked = hasWrap;
			const values = checked ? valuesFromCart(items) : [];
			const asText = list => list.map(v => lineKey(v) + "=" + lineValue(v)).sort().join("\n");
			const sameValues = asText(checked ? session.values || [] : []) === asText(values);
			const pageIsStale = Array.from(document.querySelectorAll("wrap-select")).some(
				elm => !items.some(item => item.key === elm.dataset.key)
			);
			if (!!session.checked === checked && sameValues && !pageIsStale) return;

			storeSessionProgress(values, checked);
			const checkbox = this.querySelector("#gift-wrap-checkbox");
			if (checkbox) checkbox.checked = checked;
			publish(PUB_SUB_EVENTS.cartUpdate, { source: "gift-wrapping" });
		}).catch(error => {
			console.error("Error syncing gift wrapping:", error);
		});
	}

	// Restore wrapping items based on session data
	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 42: kurven hentes i setCartState og gives med (ét opslag i stedet for to)
	async restoreWappingItems(initialData) {
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - punkt 2: gavevalg for varer, der ikke længere er i kurven, slettes,
		// så kunden ikke betaler for indpakning af en fjernet vare. Ingen valg giver 0 indpakninger (før: ingen kurvdata, så kurv-tallet blev vist som 0).

		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 7: valgene matches på linjens key i stedet for variant-ID
		const isInCart = v => initialData.items.some(item => item.key === lineKey(v));
		// Sessionen læses efter kurv-opslaget, så et gavevalg, kunden laver, mens kurven hentes, ikke overskrives
		const valuesInCart = (getParsedSessionProgress().values || []).filter(isInCart);

		// Unique gift numbers ("Gave 1", "Gave 2" ...) = number of wrappings
		// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - numrene rykkes sammen, når en vare med gave er fjernet fra kurven
		// (før kunne der stå "Gave 2" uden "Gave 1" i noten til lageret). Grupperne blandes ikke.
		const uniqueValues = Array.from(new Set(valuesInCart.map(lineValue))).sort((a, b) => giftNumber(a) - giftNumber(b));
		storeSessionProgress(valuesInCart.map(v => ({ [lineKey(v)]: `Gave ${uniqueValues.indexOf(lineValue(v)) + 1}` })));

		return this.setWrapCount(uniqueValues.length);
	}

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.6) - audit 4: sætter antallet af gaveindpakninger i kurven (0 fjerner dem).
	// Erstatter restoreWappingItems' og clearWrappingItems' to ens kurv-kald.
	async setWrapCount(count) {
		const formData = {
			updates: {
				[VARIANT_ID]: count
			}
		};

		const data = await fetch(window.Shopify.routes.root + "cart/update.js", {
			signal: requestTimeout(),
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(formData)
		})
			.then(res => res.json())
			.catch(error => {
				console.error("Error:", error);
			});

		return data;
	}

	// Set the item count display in the cart UI
	setItemCount(count) {
		const selector = ".drawer__heading__count, .cart-count-bubble__value";
		const elements = Array.from(document.querySelectorAll(selector));

		// Update all elements with the new item count
		elements.forEach(elm => {
			elm.textContent = elm.textContent.replace(NUMBER_REGEX, count);
		});
	}
}

// Define the 'gift-wrapping' custom element
customElements.define("gift-wrapping", GiftWrapping);

// Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - ingen hop: når kunden trykker "Pak ind som gave?", får afkrydsningsfeltet fokus,
// og står det lige under skuffens synlige kant, ruller browseren det frem (målt: 233-429 px). Rullepositionen huskes ved berøringen og sættes tilbage i "change".
// Begge rullende dele huskes: varelisten (cart-drawer-items) og hele skuffen (.drawer__inner, ruller på lave skærme)
function cartScrollPositions() {
	return ["cart-drawer-items", "cart-drawer .drawer__inner"]
		.map(selector => document.querySelector(selector))
		.filter(Boolean)
		.map(element => [element, element.scrollTop]);
}
function restoreCartScroll(positions) {
	(positions || []).forEach(([element, top]) => {
		if (element.isConnected && element.scrollTop !== top) element.scrollTop = top;
	});
}

// Custom element class for managing individual gift wrapping selection
class WrapSelect extends HTMLElement {
	constructor() {
		super();

		this.initialRender = true; // Flag for initial render
		this.checkbox = this.querySelector(".select__checkbox"); // Checkbox element
		this.select = this.querySelector(".select__select"); // Select dropdown element
	}

	connectedCallback() {
		// Populate the select dropdown with option values
		this.addOptionValues();

		// Add event listeners for select and checkbox changes
		this.select.addEventListener("change", this.onSelectChange.bind(this));
		this.checkbox.addEventListener("change", this.onCheckboxChange.bind(this));
		// Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - ingen hop: rullepositionen før berøringen (se cartScrollPositions)
		// Glemmes efter 1 s, så en berøring uden afkrydsning (fx træk i listen) ikke senere sætter skuffen tilbage
		this.addEventListener("pointerdown", () => {
			this.scrollBefore = cartScrollPositions();
			clearTimeout(this.scrollBeforeTimer);
			this.scrollBeforeTimer = setTimeout(() => {
				this.scrollBefore = null;
			}, 1000);
		});

		this.initialRender = false;
	}

	// Add option values to the select dropdown based on session data or existing selections
	addOptionValues() {
		const { values: storedValues, checked } = getParsedSessionProgress();

		const count =
			this.initialRender && storedValues
				? storedValues.length
				: document.querySelectorAll("wrap-select .select__checkbox:checked")
						.length;

		// Remove all existing options
		this.select.innerHTML = "";

		for (let i = 1; i <= count; i++) {
			const value = `Gave ${i}`;
			const node = document.createElement("option");

			node.dataset.index = i;
			node.value = value;
			node.textContent = value;

			// If initial render and wrapping was previously selected, restore the selection
			// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.6) - audit 5: && i stedet for & (bit-operator, virkede kun ved et tilfælde)
			if (this.initialRender && checked && storedValues) {
				// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 7: linjens key (data-key) i stedet for variant-ID
				const storedValue = storedValues.find(v => lineKey(v) === this.dataset.key);
				if (storedValue) {
					const [_, selectValue] = Object.entries(storedValue)[0];
					if (value === selectValue) {
						this.select.value = selectValue;
						node.selected = true;
					}
					this.checkbox.checked = true;
				}
			}

			// Append the option node to the select dropdown
			this.select.appendChild(node);
		}
	}

	// Handle checkbox state change
	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 41: de andre varer beholder deres gavevalg, og en ny vare får næste ledige nummer.
	// Før blev alle valg sat om efter rækkefølge (1. vare = Gave 1, 2. = Gave 2 ...), så fx "Gave 1 + Gave 1" blev til "Gave 2" og én indpakning for meget,
	// og to linjer med samme vare kunne blive ens og lagt sammen af Shopify (audit 36). Numrene rykkes sammen (Gave 1 + Gave 3 → Gave 1 + Gave 2), uden at grupper blandes.
	onCheckboxChange(e) {
		e.stopPropagation();
		// Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - ingen hop: fokus-rullet sættes tilbage
		restoreCartScroll(this.scrollBefore);
		this.scrollBefore = null;
		this.compactGifts(this.checkbox.checked ? this : null);

		// Update the cart based on the checkbox state
		this.updateCart();
	}

	// Handle select dropdown value change
	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - numrene rykkes også sammen, når kunden selv vælger et nummer (fx Gave 2 + Gave 3 → Gave 1 + Gave 2), så noten til lageret ikke har huller
	onSelectChange(e) {
		e.stopPropagation();
		// Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - ingen hop: fokus-rullet sættes tilbage
		restoreCartScroll(this.scrollBefore);
		this.scrollBefore = null;
		this.compactGifts(null);
		this.updateCart();
	}

	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 41: menuerne bygges om, uden at nogens valg går tabt. newElement (lige afkrydset) får næste ledige nummer.
	compactGifts(newElement) {
		const elements = Array.from(document.querySelectorAll("wrap-select"));
		const checkedElements = elements.filter(element => element.checkbox.checked);
		const chosen = new Map(
			checkedElements.filter(element => element !== newElement && element.select.value).map(element => [element, element.select.value])
		);
		if (newElement) {
			chosen.set(newElement, `Gave ${Math.max(0, ...Array.from(chosen.values()).map(giftNumber)) + 1}`);
		}
		// Sammenrykning efter nummer (ikke placering), så en eksisterende gave beholder sit nummer, og den nye vare får det højeste
		const renumbered = new Map(
			Array.from(new Set(chosen.values()))
				.sort((a, b) => giftNumber(a) - giftNumber(b))
				.map((value, i) => [value, `Gave ${i + 1}`])
		);

		// Update option values and select state
		elements.forEach(element => {
			element.addOptionValues();
			if (chosen.has(element)) element.select.value = renumbered.get(chosen.get(element));
		});
	}

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - antallet af indpakninger tælles nu forfra ud fra valgene (setCartState),
	// i stedet for +1/-1 pr. klik. Før gav skift fra "Gave 1" til "Gave 2" én indpakning for lidt, fordi last_count blev opdateret, før den blev sammenlignet.
	// increase()/decrease() er slettet, fordi de ikke bruges længere.
	updateCart() {
		const values = this.getActiveSelectValues();
		const isChecked = document.querySelector("#gift-wrap-checkbox").checked;

		// Store the session state with the selected values and checkbox status
		storeSessionProgress(values, isChecked);

		const giftWrapping = document.querySelector("gift-wrapping");
		if (giftWrapping) giftWrapping.setCartState(isChecked);
	}

	// Get active select values ([{ "<line key>": "Gave 1" }, ...])
	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 29: returnerer listen direkte (det ubrugte antal er fjernet)
	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 7: linjens key i stedet for variant-ID
	getActiveSelectValues() {
		const checked = Array.from(
			document.querySelectorAll("wrap-select:has(.select__checkbox:checked)")
		);
		return uniqueByLine(checked.map(elm => ({
			[elm.dataset.key]: elm.querySelector(".select__select").value
		})));
	}
}

// Function to retrieve the current cart data
async function getCartData() {
	return fetch(window.Shopify.routes.root + "cart.js", {
		signal: requestTimeout(),
		headers: {
			"Content-Type": "application/json"
		}
	}).then(res => res.json());
}

// Function to update the cart's price display
async function updateCartPrice(data) {
	// Get cart data if not provided
	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - også ved fejlsvar (fx 422, udsolgt indpakning) uden items. Før stod der "NaN" i totalen.
	if (!data || !data.items) {
		data = await getCartData();
	}

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - punkt 10: console.log fjernet. values = [], når intet er valgt (før: fejl længere nede).
	// Er gaveindpakning slået fra, skrives der ingen gavevalg på ordren (før blev de gamle valg stadig skrevet, så lageret pakkede ind uden betaling).
	const { values: storedValues = [], checked } = getParsedSessionProgress();
	const values = checked ? storedValues : [];

	// Calculate total price and format it for display
	const total = data.total_price / 100;
	const totalElement = document.querySelector(".totals__total-value");

	const targetPrice = total.toLocaleString(
		window.Shopify.locale,
		NUMBER_LOCALE_OPTIONS
	);

	// Update total price display
	totalElement.textContent = totalElement.textContent.replace(
		PRICE_REGEX,
		targetPrice
	);

	// Get the quantity of wrapping items in the cart
	const count =
		data.items.find(item => item.variant_id === VARIANT_ID)?.quantity ?? 0;

	// Calculate and format the total price for wrapping items
	const countPrice = WRAP_PRICE * Math.max(count, 1);
	const countPriceElement = document.querySelector("#cart__gift-wrap__total");

	const targetCountPrice = countPrice.toLocaleString(
		window.Shopify.locale,
		NUMBER_LOCALE_OPTIONS
	);

	// Update the wrapping items price display
	countPriceElement.textContent = countPriceElement.textContent.replace(
		PRICE_REGEX,
		targetCountPrice
	);

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 7: hver kurvlinje får sin egen værdi, fundet på linjens key.
	// Linjer, der allerede har den rigtige værdi, springes over (v3.2).
	const cartLineItems = data.items
		.map(item => {
			const chosen = values.find(v => lineKey(v) === item.key);
			return { item, value: chosen ? lineValue(chosen) : "" };
		})
		.filter(({ item, value }) => ((item.properties && item.properties.Gaveindpakning) || "") !== value);

	// Loop through each item and update it individually
	let latestCart = data;
	// Tomme egenskaber tæller ikke med (Shopify kan udelade dem i svaret)
	const asText = props => JSON.stringify(Object.entries(props || {}).filter(([, v]) => v !== "" && v != null).sort());
	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 36: linjerne skrives fra en kø. Ligner en linje en anden linje, som selv skal skifte gave,
	// skrives den anden først (ellers bliver de ens et øjeblik, og Shopify lægger dem sammen med antal 1, så en vare forsvinder).
	const queue = cartLineItems.map(({ item, value }) => ({ item, value }));
	let deferrals = queue.length;
	while (queue.length) {
		const { item, value } = queue.shift();
		const current = latestCart.items.find(cartItem => cartItem.key === item.key);
		if (!current) continue;
		// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.4) - audit 1: Shopify erstatter ALLE linjens egenskaber.
		// Varens andre egenskaber (fx _Preorder eller gavekortets modtager) sendes derfor med, så de ikke forsvinder fra ordren.
		const properties = { ...(current.properties || {}), Gaveindpakning: value };
		// Lavet af Christian Andrés (20-10-2026) - projekt: pagespeed (v3.9) - audit #2: antallet sendes med. Shopifys change.js med kun properties sætter antallet til 1 (3 stk. → 1 stk.)
		const formData = {
			id: item.key,
			quantity: current.quantity,
			properties
		};

		// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 36: bliver linjen magen til en anden linje med samme vare (fx samme størrelse i samme gave),
		// lægges de selv sammen her: den anden linje får begge antal, og denne linje fjernes. Før lagde Shopify dem sammen med antal 1, så en vare forsvandt fra kurven.
		// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 42: ét kald (cart/update.js med begge linjers key), så det sker helt eller slet ikke.
		// Før var det to kald; fejlede det andet, stod antallet for højt, og næste kørsel kunne lægge det på igen.
		const twin = latestCart.items.find(
			cartItem => cartItem.key !== item.key && cartItem.variant_id === item.variant_id && asText(cartItem.properties) === asText(properties)
		);
		const twinMovesAway = twin && queue.some(job => job.item.key === twin.key && job.value !== value);
		if (twinMovesAway && deferrals-- > 0) {
			queue.push({ item, value });
			continue;
		}
		if (twin && !twinMovesAway) {
			try {
				const mergeResponse = await fetch(window.Shopify.routes.root + "cart/update.js", {
					signal: requestTimeout(),
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ updates: { [twin.key]: twin.quantity + current.quantity, [current.key]: 0 } })
				});
				if (!mergeResponse.ok) continue;
				const cart = await mergeResponse.json();
				if (cart && cart.items) latestCart = cart;
				rememberNewLineKey(current.key, twin.key);
			} catch (error) {
				console.error("Error merging items:", error);
			}
			continue;
		}
		// (Kan køen ikke løses, fx to linjer der bytter gave, skrives linjen som før)

		try {
			const response = await fetch("/cart/change.js", {
				signal: requestTimeout(),
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify(formData)
			});
			const cart = await response.json();
			if (!response.ok || !cart.items) continue;
			latestCart = cart;
			// Linjen har fået en ny key, fordi dens egenskaber er ændret (v3.5, punkt 7)
			const sameProperties = other => asText(other) === asText(properties);
			const sameVariant = cart.items.filter(cartItem => cartItem.variant_id === item.variant_id);
			// Reserve: er der kun én linje med varen, er det den
			const changed = sameVariant.find(cartItem => sameProperties(cartItem.properties)) || (sameVariant.length === 1 ? sameVariant[0] : null);
			if (changed) rememberNewLineKey(item.key, changed.key);
		} catch (error) {
			console.error("Error updating item:", error);
		}
	}

	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - punkt 1: kundens egen note bevares. Kun linjen "Gaveindpakning: ..." skiftes ud
	// (før blev hele noten overskrevet, så fx "Må stilles ved døren" forsvandt). Noter i det gamle format ("123 - Gave 1, ...") fjernes også.
	// Update the cart note with the selected gift wrapping options
	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - punkt 6: noten viser produktnavn og størrelse i stedet for variant-ID,
	// fx "Gaveindpakning: 156409 | Gustav - Stacie Beige (Beige / 38) - Gave 1; ...". Semikolon, fordi et produktnavn kan indeholde komma.
	// Noten bygges ud fra linjerne, som de står i kurven efter skrivningen, så den altid passer med ordren (også når Shopify lægger ens linjer sammen).
	const cartNote = latestCart.items
		.filter(item => item.properties && item.properties.Gaveindpakning)
		.map(item => {
			const name = item.variant_title ? `${item.product_title} (${item.variant_title})` : item.product_title;
			return `${name} - ${item.properties.Gaveindpakning}`;
		})
		.join("; ");

	const GIFT_NOTE_PREFIX = "Gaveindpakning: ";
	const OLD_GIFT_NOTE = /^\d+ - Gave \d+(, \d+ - Gave \d+)*$/;
	// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.5) - noten læses fra den nyeste kurv
	const oldNote = latestCart.note || "";
	const customerNote = oldNote
		.split("\n")
		.filter(line => !line.startsWith(GIFT_NOTE_PREFIX) && !OLD_GIFT_NOTE.test(line.trim()))
		.join("\n")
		.trim();
	const newNote = [customerNote, cartNote ? GIFT_NOTE_PREFIX + cartNote : ""].filter(Boolean).join("\n");

	if (newNote !== oldNote) {
		const formDataNote = {
			note: newNote
		};

		try {
			const noteResponse = await fetch(
				window.Shopify.routes.root + "cart/update.js",
				{
					signal: requestTimeout(),
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify(formDataNote)
				}
			);
			await noteResponse.json();
		} catch (error) {
			console.error("Error updating cart note:", error);
		}
	}

	// Lavet af Christian Andrés (19-10-2026) - projekt: pagespeed (v3.7) - audit 36 + 42: den nyeste kurv gives tilbage, så setCartState kan tegne skuffen om,
	// når linjerne er ændret (også når linjer er lagt sammen). Noten ændrer ikke linjerne.
	return latestCart;
}

// Function to clear session progress data
function clearSessionProgress() {
	sessionStorage.removeItem(SESSION_KEY);
}

// Function to store session progress data (gift wrap selections)
function storeSessionProgress(values, checked) {
	const data = getParsedSessionProgress();
	if (values !== undefined) {
		data.values = values;
	}
	if (checked !== undefined) {
		data.checked = checked;
	}
	sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
}

// Function to retrieve and parse session progress data
function getParsedSessionProgress() {
	try {
		const stored = sessionStorage.getItem(SESSION_KEY);
		if (!stored) return {};
		return JSON.parse(stored);
	} catch (_) {
		return {};
	}
}

// Define the 'wrap-select' custom element
customElements.define("wrap-select", WrapSelect);
